import { FC } from "react";
import { Field, FieldRenderProps } from "react-final-form";

import { Input } from "@livechat/design-system-react-components";

import { FormFieldNoMargin } from "components/design-system-adapters/styled/form-field";

interface IProps {
  name: string;
}

export const HeaderBlock: FC<IProps> = ({ name }) => {
  return (
    <Field<string> name={`${name}.value`}>
      {({ input, meta }) => (
        <FormFieldNoMargin
          labelText="Header content"
          css={{ display: "flex", flexDirection: "column" }}
          error={meta.error}
        >
          <HeaderBlockInput input={input} meta={meta} />
        </FormFieldNoMargin>
      )}
    </Field>
  );
};

const HeaderBlockInput: FC<FieldRenderProps<string>> = ({ input, meta }) => {
  return <Input {...input} error={meta.error} data-testid="header-input-label" />;
};
